import React, {useState} from 'react';
import {ProductInDepotType} from '../../../types/ProductSliceTypes';
import s from '../../CreateInvoice/CreateInvoicePopup/CreateInvoicePopup.module.css';
import LightGreenButton from '../../../Components/Buttons/LightGreenButton';
import {useTranslation} from 'react-i18next';
import {UserClient} from '../../../types/TypesUser';
import VeryLightGreenButton from '../../../Components/Buttons/VeryLightGreenButton';
import {useFormikContext} from 'formik';
import {CreateDesignType} from '../../../types/TypesStore';
import PayTypeSelector from '../../../Components/CreateAndEditOrderComponents/PayTypeSelector/PayTypeSelector';
import CreatePopupBase from '../../../Components/CreatePopupBase/CreatePopupBase';
import BonusHandler from '../components/BonusHandler/BonusHandler';
import {useGetClientsPresentQuery} from '../../../redux/userClientsApi';

type Props = {
	close: () => void;
	prepareProducts: ProductInDepotType[];
	changeProductCallback: (
		id: string,
		action: '+' | '-' | 'manual' | 'remove',
		value?: number,
	) => void;
	prroStatus?: boolean;
	client: UserClient;
};
const CreateDesignPopup: React.FC<Props> = ({
	close,
	prepareProducts,
	changeProductCallback,
	client,
	prroStatus = true,
}) => {
	const {t} = useTranslation();
	const {values, setFieldValue} = useFormikContext<CreateDesignType>();
	const [isBonusConfirmed, setIsBonusConfirmed] = useState(false);
	const {data, isLoading, error} = useGetClientsPresentQuery(client?.client_id);
	const [isWelcomeBoxAdded, setIsWelcomeBoxAdded] = useState(false);

	const handleChangeStatus = (status: 'created' | 'approved') => {
		setFieldValue('status', status);
	};

	// Обработчик добавления WelcomeBox продуктов
	const handleAddWelcomeBox = () => {
		if (data?.present && data.present.length > 0) {
			// Добавляем каждый продукт из подарка
			data.present.forEach((presentProduct) => {
				// Проверяем, не добавлен ли уже этот продукт
				const isAlreadyAdded = prepareProducts.some(
					(p) => p.id === presentProduct.product_id.toString(),
				);

				if (!isAlreadyAdded) {
					// Добавляем продукт с количеством 1
					changeProductCallback(presentProduct.product_id.toString(), '+');
				}
			});
			setIsWelcomeBoxAdded(true);
		}
	};

	// Обработчик подтверждения бонусов
	const handleBonusConfirmed = (confirmed: boolean) => {
		setIsBonusConfirmed(confirmed);
	};

	// Проверяем, можно ли сохранить без подтверждения бонусов
	const canSaveWithoutBonusConfirmation = () => {
		const bonusAmount = +values.bonus;
		const hasClientMoney = client?.money && +client.money > 0;

		// Если нет бонусов у клиента или клиент не указал сумму бонусов - можно сохранить
		if (!hasClientMoney || bonusAmount === 0 || values.bonus === '') {
			return true;
		}

		// Если указаны бонусы - нужно подтверждение
		return isBonusConfirmed && values.approveCode;
	};
	// Проверяем наличие подарка (WelcomeBox)
	const hasPresent = data?.present && data.present.length > 0;
	const presentName = hasPresent ? data.present[0].name : '';

	return (
		<CreatePopupBase
			close={close}
			prepareProducts={prepareProducts}
			changeProductCallback={changeProductCallback}
		>
			{/* Блок с WelcomeBox, если есть подарок */}
			{hasPresent && !isWelcomeBoxAdded && (
				<div className={s.blockWrapper}>
					<div className={s.welcomeBoxContainer}>
						<div className={s.welcomeBoxText}>
							{t('Отримати')} {presentName}
						</div>
						<LightGreenButton
							text={t('Додати подарунок')}
							type="button"
							onClick={handleAddWelcomeBox}
						/>
					</div>
				</div>
			)}

			{/* Сообщение о добавленном подарке */}
			{isWelcomeBoxAdded && (
				<div className={s.blockWrapper}>
					<div className={s.welcomeBoxAdded}>
						✓ {presentName} {t('додано до оформлення')}
					</div>
				</div>
			)}

			{prroStatus && client && (
				<div className={s.blockWrapper}>
					<BonusHandler
						client={client}
						onBonusConfirmed={handleBonusConfirmed}
					/>
					<PayTypeSelector />
				</div>
			)}
			<div className={s.buttonsContainer}>
				<LightGreenButton
					onClick={() => handleChangeStatus('created')}
					text={t('Зберегти як чернетку')}
					type={'submit'}
					disabled={!canSaveWithoutBonusConfirmation()}
				/>
				<VeryLightGreenButton
					onClick={() => handleChangeStatus('approved')}
					text={t('Підтвердити')}
					type={'submit'}
					disabled={!canSaveWithoutBonusConfirmation()}
				/>
			</div>
		</CreatePopupBase>
	);
};

export default CreateDesignPopup;
